<template>
  <div v-if="showFooter" :class="['sp_bottom_menu', hideDisplay]">
    <div class="sp_bottom_menu_1">
      <div class="layout_change_sp">
        <ul>
          <li>
            <input
              type="radio"
              id="layout_change01"
              name="layout_change"
              class="layout_change01"
              v-model="activeTab"
              value="chat"
              @change="setActiveTab()"
            />
            <label for="layout_change01">
              <span></span>
            </label>
          </li>
          <li v-if="!isAssistLesson">
            <input
              type="radio"
              id="layout_change02"
              name="layout_change"
              class="layout_change02"
              v-model="activeTab"
              value="material"
              @change="setActiveTab()"
            />
            <label for="layout_change02">
              <span></span>
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="layout_change03"
              name="layout_change"
              class="layout_change03"
              v-model="activeTab"
              value="menu"
              @change="setActiveTab()"
            />
            <label for="layout_change03">
              <span></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    hideDisplay: {
      type: String,
      default: ''
    },
    trialLesson: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'chat'
    };
  },
  watch: {
    isMenuVisible(state) {
      this.activeTab = state ? 'menu' : this.activeTab;
    }
  },
  computed: {
    ...mapState('layout', ['isMenuVisible', 'isMobileSize']),
    ...mapGetters(['isAssistLesson']),
    ...mapGetters('modal', ['isModalShowing']),

    showFooter() {
      if (this.isMobileSize && this.isModalShowing) {
        return false;
      }

      return true;
    }
  },
  methods: {
    ...mapActions('layout', ['switchMaterialState']),
    ...mapMutations('layout', ['setIsMenuVisible']),

    setActiveTab() {
      if (this.activeTab === 'menu') {
        this.setIsMenuVisible(!this.isMenuVisible);
      } else {
        this.setIsMenuVisible(false);
        this.switchMaterialState(this.activeTab);
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/sp/bottom_menu.css"></style>
